var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewGrid = function SvgViewGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.9,
    viewBox: "0 0 24 24",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.5,
    x: 3,
    y: 3,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.5,
    x: 13.5,
    y: 3,
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.5,
    x: 3,
    y: 13.5,
    rx: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 7.5,
    x: 13.5,
    y: 13.5,
    rx: 1.5
  })));
};
export default SvgViewGrid;